import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContCoreBancarioPage,
  ContHeroCoreBancario,
  DescCoreBancario,
  ContButton,
  ContImg,
  TitleWrapper
} from './CoreBancarioPage.styles';
import ButtonSpecial from '../../components/ButtonSpecial';
import TitleSpecial from '../../components/TitleSpecial';
import CoreBancarioImagesContainer from '../../components/CoreBancarioImagesContainer';
import { CoreBancarioCreateTech } from '../../components/CoreBancarioCreateTech';
import { CoreBancarioClients } from '../../components/CoreBancarioClients';
import { CoreBancarioFAQ } from '../../components/CoreBancarioFAQ';
import CoreBancarioModulos from '../../components/CoreBancarioModulos';
import CoreBancarioCasosUso from '../../components/CoreBancarioCasosUso';

export const CoreBancarioPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ContCoreBancarioPage id={'ContCoreBancarioPage'}>
      <ContHeroCoreBancario>
        <TitleWrapper>
          <TitleSpecial>
            {t('Un Core Bancario que va más allá')}
          </TitleSpecial>
        </TitleWrapper>
        <DescCoreBancario >
          {t('La transformación de tu empresa comienza con la tecnología adecuada: una ')}
          <span>{t('plataforma modular')}</span>
          {t(' que digitaliza y automatiza tu operación de principio a fin.')}
        </DescCoreBancario>
        <ContButton id={'ContButtonCenter'}>
          <ButtonSpecial text={t('Solicita una Demo')} type={'/'} linkTo={'/contacto'} target={'_self'} />
        </ContButton>
      </ContHeroCoreBancario>

      <ContImg id={'ContImg'}>
        <CoreBancarioImagesContainer />
      </ContImg>

      <CoreBancarioModulos />
      <CoreBancarioCasosUso />
      <CoreBancarioCreateTech />
      <CoreBancarioClients />
      <CoreBancarioFAQ />
    </ContCoreBancarioPage>
  )
}
